const base64URLEncode = (buffer: ArrayBuffer): string =>
  btoa(String.fromCharCode.apply(null, new Uint8Array(buffer)))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=/g, '')

const sha256 = (plain: string): Promise<ArrayBuffer> =>
  crypto.subtle.digest('SHA-256', new TextEncoder().encode(plain))

const randomBase64URL = (byteLength: number): string =>
  base64URLEncode(crypto.getRandomValues(new Uint8Array(byteLength)).buffer)

export const generateState = (): string => randomBase64URL(16)

export const generateNonce = (): string => randomBase64URL(16)

export const generateCodeVerifier = async (): Promise<{
  code_verifier: string
  code_challenge: string
}> => {
  const code_verifier = randomBase64URL(32)
  const code_challenge = base64URLEncode(await sha256(code_verifier))

  return { code_verifier, code_challenge }
}
